import React, { useEffect, useState, useRef, Component } from 'react';
import { Share2Icon, MessageCircleIcon, LinkIcon, CheckIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ShareButtonProps {
  productId: string;
  productName: string;
  productPrice: number;
  promoCode?: string;
  className?: string;
}
export function ShareButton({
  productId,
  productName,
  productPrice,
  promoCode,
  className = ''
}: ShareButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const productLink = `${window.location.origin}/product/${productId}`;
  const whatsappGroupLink = 'https://chat.whatsapp.com/IkRgOt1lq4OGk2v9SDVqYa?mode=gi_t';
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleWhatsAppShare = () => {
    let message = `🛍️ Check out *${productName}* on Sky Brand!\n💰 Price: ₹${productPrice}\n🔗 ${productLink}\n`;
    if (promoCode) {
      message += `🎁 Use code: *${promoCode}* for extra discount!\n`;
    }
    message += `\n👥 Join our WhatsApp group for exclusive offers: ${whatsappGroupLink}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(productLink);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      setIsOpen(false);
    }, 2000);
  };
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Sky Brand - ${productName}`,
          text: `Check out ${productName} for ₹${productPrice}!`,
          url: productLink
        });
        setIsOpen(false);
      } catch (error) {
        console.log('Error sharing:', error);
      }
    }
  };
  return <div className="relative inline-block" ref={dropdownRef} data-id="element-309">
      <button onClick={e => {
      e.preventDefault();
      setIsOpen(!isOpen);
    }} className={`p-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm hover:bg-white transition-colors text-slate-400 hover:text-sky-600 ${className}`} aria-label="Share product" data-id="element-310">
        <Share2Icon className="w-5 h-5" data-id="element-311" />
      </button>

      <AnimatePresence data-id="element-312">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.15
      }} className="absolute right-0 top-full mt-2 w-48 bg-white rounded-xl shadow-lg border border-slate-100 py-2 z-50" data-id="element-313">
            <button onClick={handleWhatsAppShare} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-green-50 hover:text-green-600 transition-colors" data-id="element-314">
              <MessageCircleIcon className="w-4 h-4" data-id="element-315" />
              Share on WhatsApp
            </button>

            <button onClick={handleCopyLink} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-316">
              {copied ? <CheckIcon className="w-4 h-4 text-green-500" data-id="element-317" /> : <LinkIcon className="w-4 h-4" data-id="element-318" />}
              {copied ? 'Link Copied!' : 'Copy Link'}
            </button>

            {navigator.share && <button onClick={handleNativeShare} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors border-t border-slate-100 mt-1 pt-3" data-id="element-319">
                <Share2Icon className="w-4 h-4" data-id="element-320" />
                More Options
              </button>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}